import Vue from "vue";
import { login, getInfo, logout, msmsreg, smslogin } from "@/http/user";
import tooken from "@/utils/tooken";

const user = {
  state: {
    token: "",
    info: {}
  },
  mutations: {
    //设置token
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    //设置用户信息
    SET_INFO: (state, info) => {
      state.info = info;

      // 记录 uid 到 arms 监控
      Vue.prototype.__bl &&
        Vue.prototype.__bl.setConfig({
          setUsername: function() {
            return info.uid;
          }
        });
    },
    //重置用户信息与token
    RESET: state => {
      state.token = "";
      state.info = {};
    }
  },

  actions: {
    // 账号登录
    Login({ commit }, { params, callback }) {
      return new Promise((resolve, reject) => {
        login(params)
          .then(res => {
            if (res.rcode === 0) {
              const data = res.data;
              tooken.setCookieToken(data);
              commit("SET_TOKEN", data.token);
              if (callback) callback(res.rcode);
              resolve();
            } else {
              if (callback) callback(res.rcode);
              reject();
            }
          })
          .catch(() => {
            if (callback) callback(-1);
            reject();
          });
      });
    },
    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then(res => {
            if (res.rcode === 0) {
              commit("SET_INFO", res.data);
              resolve();
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
          });
      });
    },
    // 登出
    Logout({ commit }, isRequest) {
      return new Promise(resolve => {
        tooken.removeCookieToken();
        if (isRequest) {
          logout().finally(() => {
            commit("RESET");
            resolve();
          });
        } else {
          commit("RESET");
          resolve();
        }
      });
    },
    //手机注册
    PhoneReg({ commit }, regInfo) {
      return new Promise((resolve, reject) => {
        msmsreg(regInfo)
          .then(res => {
            if (res.rcode === 0) {
              const data = res.data;
              tooken.setCookieToken(data);
              commit("SET_TOKEN", data.token);
            }
            resolve(res);
          })
          .catch(() => {
            reject();
          });
      });
    },
    //手机登录
    PhoneLogin({ commit }, regInfo) {
      return new Promise((resolve, reject) => {
        smslogin(regInfo)
          .then(res => {
            if (res.rcode === 0) {
              const data = res.data;
              tooken.setCookieToken(data);
              commit("SET_TOKEN", data.token);
            }
            resolve(res);
          })
          .catch(() => {
            reject();
          });
      });
    },
    //设置token
    SetToken({ commit }, token) {
      commit("SET_TOKEN", token);
    }
  }
};

export default user;
